/***
 * Класс вывода ошибок для блоков
 */
export class BlockError {
	/***
	 * @param blockName {String} названия блока. Тот текст, который будет добавляться в начало ошибки;
	 * @param destroy {Function} функция удаления блока, которая будет вызвана при ошибке
	 */
  constructor({ blockName = 'BlockError', destroy = Function() }) {
		this.blockName = blockName;
		this.destroy = destroy;
  }

	/***
	 * Функция вывода предупреждения
	 * @param messageText {String} - текст предупреждения
	 */
	warnMessage = (messageText) => {
		console.warn(`${this.blockName}: ${messageText}`);
	};

	/***
	 * Функция вывода ошибки
	 * @param messageText {String} - текст ошибки
	 */
	errorMessage = (messageText) => {
		console.error(`${this.blockName}: ${messageText}`);
	};

	/**
	 * Функция выброса ошибка
	 * @param messageText {String} - текст ошибки
	 */
	throwError = (messageText) => {
		throw new Error(`${this.blockName}: ${messageText}`);
	};

	/**
	 * Вывод ошибки и удаление блока с остановкой работы
	 * @param messageText {String} - текст ошибки
	 * @return {null}
	 */
	error = (messageText) => {
		this.errorMessage(messageText);
		if (this.destroy) this.destroy();
		return null;
	};
}
